import React from "react";
import { AuthValues } from '../types'

const defaultValue: AuthValues = {
  authorizations: [],
  authorizationsState: 'loading',
  retryAuthorizations: () => null,
}

const AuthContext = React.createContext(defaultValue);

export default AuthContext;
